<template>
  <v-container fluid>
    <CompraSwisstex v-if="$store.state.emp.id_empresa == 49" />
    <CompraConab v-if="$store.state.emp.id_empresa == 55" />
    <CompraIBM v-if="$store.state.emp.id_empresa == 57" />
    <CompraTX v-if="$store.state.emp.id_empresa == 58" /> 
    <ComprasHYGGE v-if="$store.state.emp.id_empresa == 91" />
    <ComprasUnique v-if="$store.state.emp.id_empresa == 50" />
    <CompraNaka v-if="$store.state.emp.id_empresa == 96" />
    <CompraPrueba v-if="$store.state.emp.id_empresa == 193" />
    <CompraDLM v-if="$store.state.emp.id_empresa == 124" />
    <CompraJadip v-if="$store.state.emp.id_empresa == 125" />
    <CompraVeintinueve v-if="$store.state.emp.id_empresa == 128" />
    <CompraErret v-if="$store.state.emp.id_empresa == 136" />
    <CompraAbel v-if="$store.state.emp.id_empresa == 139" />
    <CompraAstra v-if="$store.state.emp.id_empresa == 140" />
    <CompraSuc v-if="$store.state.emp.id_empresa == 155" />
    <ComprasVegeta v-if="$store.state.emp.id_empresa == 159" />
    <CompraSerprore v-if="$store.state.emp.id_empresa == 152" />
    <CompraFalcon v-if="$store.state.emp.cod_empresa == 482" />
    <CompraPno v-if="$store.state.emp.id_empresa == 119" />
    <CompraRatel v-if="$store.state.emp.id_empresa == 158" />
    <CompraConsultoria v-if="$store.state.emp.id_empresa == 166" />
    <CompraIngredienta v-if="$store.state.emp.id_empresa == 175" />
    <CompraCorporacion v-if="$store.state.emp.id_empresa == 180" />
    <CompraYeyi v-if="$store.state.emp.id_empresa == 181" />
    <compra-iotecsa v-if="$store.state.emp.id_empresa == 182" />
    <compra-ana v-if="$store.state.emp.id_empresa == 184" />
    <CompraTeam v-if="$store.state.emp.id_empresa == 190" />
    <CompraFrancisco v-if="$store.state.emp.id_empresa == 200 " />
    <CompraWalter v-if="$store.state.emp.id_empresa == 213 " />
    <CompraIrma v-if="$store.state.emp.id_empresa == 216 " />
    <CompraJoseAngelCruz v-if="$store.state.emp.id_empresa == 212 " />
    <CompraBilly v-if="$store.state.emp.id_empresa == 214 " />
    <ComprasEuracio v-if="$store.state.emp.id_empresa == 222 " />
    <ComprasIdeas v-if="$store.state.emp.id_empresa == 231 " />
    <ComprasContreras v-if="$store.state.emp.id_empresa == 243 " />
    <ComprasMaximiliano v-if="$store.state.emp.id_empresa == 244 " />
    <ComprasCarlosN v-if="$store.state.emp.id_empresa == 246 " />
    <ComprasHersot v-if="$store.state.emp.id_empresa == 248 " />
    <ComprasWilliam v-if="$store.state.emp.id_empresa == 250 " />
    <CompraGino v-if="$store.state.emp.id_empresa == 252 " />

    <div v-if="
      $store.state.emp.id_empresa != 49 &&
      $store.state.emp.id_empresa != 55 &&
      $store.state.emp.id_empresa != 57 &&
      $store.state.emp.id_empresa != 58 &&
      $store.state.emp.id_empresa != 91 &&
      $store.state.emp.id_empresa != 50 &&
      $store.state.emp.id_empresa != 96 &&
      $store.state.emp.id_empresa != 193 && //Prueba
      $store.state.emp.id_empresa != 124 &&
      $store.state.emp.id_empresa != 125 &&
      $store.state.emp.id_empresa != 128 &&
      $store.state.emp.id_empresa != 136 &&
      $store.state.emp.id_empresa != 139 &&
      $store.state.emp.id_empresa != 190 &&
      $store.state.emp.id_empresa != 140 &&
      $store.state.emp.id_empresa != 155 &&
      $store.state.emp.id_empresa != 159 &&
      $store.state.emp.id_empresa != 152 &&
      $store.state.emp.id_empresa != 482 &&
      $store.state.emp.id_empresa != 119 &&
      $store.state.emp.id_empresa != 158 &&
      $store.state.emp.id_empresa != 166 &&
      $store.state.emp.id_empresa != 175 &&
      $store.state.emp.id_empresa != 180 &&
      $store.state.emp.id_empresa != 181 &&
      $store.state.emp.id_empresa != 182 &&
      $store.state.emp.id_empresa != 184 &&
      $store.state.emp.id_empresa != 200 &&
      $store.state.emp.id_empresa != 213 &&
      $store.state.emp.id_empresa != 216 &&
      $store.state.emp.id_empresa != 212 &&
      $store.state.emp.id_empresa != 214 &&
      $store.state.emp.id_empresa != 222 &&
      $store.state.emp.id_empresa != 231 &&
      $store.state.emp.id_empresa != 243 &&
      $store.state.emp.id_empresa != 244 &&
      $store.state.emp.id_empresa != 246 &&
      $store.state.emp.id_empresa != 248 &&
      $store.state.emp.id_empresa != 250 &&
      $store.state.emp.id_empresa != 252
    ">
      <lottie :options="defaultOptions" :height="350" :width="350" v-on:animCreated="handleAnimation" />
    </div>

  </v-container>
</template>

<script>
import CompraConab from "./Conab/CompraConab.vue";
import CompraSwisstex from "./Swisstex/CompraSwisstex.vue";
import CompraIBM from "./IBMaker/CompraIBM.vue";
import CompraTX from "./TXOOL/CompraTX.vue";
import CompraSperidian from "./Speridian/CompraSperidian.vue";
import ComprasHYGGE from "./HYGGE/ComprasHYGGE.vue";
import ComprasUnique from "./Unique/UniqueC.vue";
import CompraNaka from "./Naka/CompraNaka.vue";
import CompraPrueba from "./CompraPrueba.vue";
import CompraDLM from "./DLM/CompraDLM.vue";
import CompraJadip from "./Jadip/CompraJadip.vue";
import CompraVeintinueve from "./Veintinueve/CompraVeintinueve.vue";
import CompraErret from "./Erret/CompraErret.vue";
import CompraAbel from "./Abel/CompraAbel.vue";
import CompraAstra from "./Astra/CompraAstra.vue";
import CompraSuc from "./SucGomez/CompraSuc.vue";
import ComprasVegeta from "./Vegeta/ComprasVegeta.vue";
import CompraSerprore from "./Serprore/CompraSerprore.vue";
import CompraFalcon from "./Falcon/CompraFalcon.vue";
import CompraPno from "./PNO/ComprasPno.vue";
import CompraRatel from "./Ratel/CompraRatel.vue";
import CompraConsultoria from "./Consultoria/CompraConsultoria.vue";
import CompraIngredienta from "./Ingredienta/CompraIngredienta.vue";
import CompraCorporacion from "./Corporacion/CompraCorporacion.vue";
import CompraYeyi from "./Yeyi/CompraYeyi.vue";
import CompraIotecsa from './Iotecsa/CompraIotecsa.vue';
import CompraAna from './Ana/CompraAna.vue';
import CompraTeam from './Team/CompraTeam.vue';
import CompraFrancisco from './Francisco/CompraFrancisco.vue';
import CompraJoseAngelCruz from "./JoseAngelCruz/CompraJoseAngelCruz.vue";
import * as animationData from "../../animations/no_datta.json";
import CompraWalter from "./Walter/CompraWalter.vue";
import CompraIrma from "./CompraIrma/CompraIrme.vue";
import CompraBilly from "./Billy/CompraBilly.vue";
import ComprasEuracio from "./Euracio/ComprasEuracio.vue";
import ComprasIdeas from "./Ideas/CompraIdeas.vue";
import ComprasContreras from "./MContreras/CompraMcontreras.vue";
import ComprasMaximiliano from "./Maximiliano/ComprasMaximiliano.vue";
import ComprasCarlosN from "./CarlosNieto/CompraCarlosN.vue";
import ComprasHersot from "./Hersot/ComprasHersot.vue";
import ComprasWilliam from "./William/ComprasWilliam.vue";
import CompraGino from "./Gino/ComprasGino.vue";

import Lottie from "vue-lottie";

export default {
  data: () => ({
    defaultOptions: { animationData: animationData },
    animationSpeed: 1,
  }),
  components: {
    Lottie,
    CompraSwisstex,
    CompraConab,
    CompraIBM,
    CompraTX,
    CompraSperidian,
    ComprasHYGGE,
    ComprasUnique,
    CompraNaka,
    CompraPrueba,
    CompraDLM,
    CompraJadip,
    CompraVeintinueve,
    CompraErret,
    CompraAbel,
    CompraAstra,
    CompraSuc,
    ComprasVegeta,
    CompraSerprore,
    CompraFalcon,
    CompraPno,
    CompraRatel,
    CompraConsultoria,
    CompraIngredienta,
    CompraCorporacion,
    CompraYeyi,
    CompraIotecsa,
    CompraAna,
    CompraTeam,
    CompraFrancisco,
    CompraWalter,
    CompraIrma,
    CompraJoseAngelCruz,
    CompraBilly,
    ComprasEuracio,
    ComprasIdeas,
    ComprasContreras,
    ComprasMaximiliano,
    ComprasCarlosN,
    ComprasHersot,
    ComprasWilliam,
    CompraGino
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
    },
  },
};
</script>